export function addFlow3SuffixToProductId(productId?: string): string {
    return productId ? `${productId}-flow3` : productId;
}

export function removeFlow3SuffixFromProductId(productId?: string): string {
    return productId ? productId.replace(/-flow3$/, "") : productId;
}

export function hasFlow3Suffix(productId?: string): boolean {
    return productId?.endsWith("-flow3");
}

export function appendDisplayFlow3Suffix(productName?: string): string {
    if (productName) {
        return `${productName} (ext)`;
    }

    return productName;
}
